<section class="col-seleccion enLocalizador">
  <div class="tituloInt tituloLocalizador">{{ 'BUSCADOR_DE_LOCALIZADORES' | translateV2 }}</div>
  <div class="onoffswitch-wrapGeneral filtroCentro" *ngIf="mostrarFiltro()">
    <div class="onoffswitch-wrap checked">
      <div class="onoffswitch" [formGroup]="localizadorForm">
        <input
          type="checkbox"
          name="filtrarCentroCheck"
          id="filtrarCentroCheck"
          class="onoffswitch-checkbox"
          formControlName="filtrarCentro"
          (change)="changefiltrarCentro()"
          [checked]="filtrarCentro"
        />
        <label class="onoffswitch-label" for="filtrarCentroCheck"></label>
      </div>
      <label class="onoffswitch-label-text" for="filtrarCentroCheck">{{
        'FILTRARCENTRO' | translate
      }}</label>
    </div>
  </div>
  <div class="ticket-info localiza-info" [formGroup]="localizadorForm">
    <div class="inputControl">
      <input
        class="localizador"
        type="text"
        #localizadorInput
        category="ALFANUMERICO"
        formControlName="localizador"
        placeholder="{{ 'BUSCAR' | translate }}"
        (focus)="focusValue($event)"
      />
      <img
        *ngIf="localizadorInput.value === ''"
        class="svg"
        src="assets/img/icon-search.svg"
        alt="icono busqueda"
      />
      <div
        class="close"
        [ngStyle]="{
          visibility: localizadorInput.value === '' ? 'hidden' : 'visible',
          opacity: localizadorInput.value === '' ? 0 : 1
        }"
      >
        <a
          title="{{ 'CERRAR' | translateV2 }}"
          (click)="localizadorForm.controls['localizador'].patchValue('')"
          ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translateV2 }}</span></a
        >
      </div>
    </div>
    <div class="inputControl calendar">
      <a class="prev" title="Previo" (click)="backDia()">
        <img class="svg" src="assets/img/active-arrow.svg" alt="Previo" />
      </a>
      <input
        class="localizador"
        type="text"
        formControlName="fecha"
        placeholder="{{ 'FILTRAR_POR_DIA' | translateV2 }}"
        (click)="openModal('datePicker')"
        #fechaLocalizador
      />
      <div
        class="close"
        [ngStyle]="{
          visibility: fechaLocalizador.value === '' ? 'hidden' : 'visible',
          opacity: fechaLocalizador.value === '' ? 0 : 1
        }"
      >
        <a title="cerrar" (click)="deleteDate()"
          ><span class="cross"></span><span class="sr-only">cerrar</span></a
        >
      </div>
      <a class="next" title="Próximo" (click)="nextDia()">
        <img class="svg" src="assets/img/active-arrow.svg" alt="Próximo" />
      </a>
    </div>
  </div>

  <ng-container *ngIf="!localizadorService.loadingBuscador; else cargando2">
    <div
      class="Rtable"
      *ngIf="pagedItems && pagedItems.length !== 0; else noResults"
    >
      <div class="Rtable-row Rtable-row--head">
        <div class="Rtable-cell status-cell column-heading">STATUS</div>
        <div class="Rtable-cell localizador-cell column-heading">
          {{ 'LOCALIZADOR' | translateV2 }}
        </div>
        <div class="Rtable-cell fecha-cell column-heading">{{ 'FECHA_Y_HORA' | translateV2 }}</div>
        <div class="Rtable-cell cliente-cell column-heading">{{ 'NUM_PEDIDO' | translateV2 }}</div>
        <div class="Rtable-cell cliente-cell column-heading">
          Nº {{ 'TOTAL_ENTRADAS' | translateV2 }}
        </div>
        <div class="Rtable-cell correo-cell column-heading">
          {{ 'CORREO_ELECTRONICO' | translateV2 }}
        </div>
      </div>

      <div class="listado" id="entradas">
        <!--         <div
          (click)="cargarEntradas(reserva)"
          class="Rtable-row"
          *ngFor="let reserva of pagedItems"
          [ngClass]="selectedReservaClass(reserva)"
        > -->
        <div
          class="Rtable-row"
          *ngFor="let reserva of pagedItems"
          [ngClass]="selectedReservaClass(reserva)"
          [routerLink]="[reserva.ClaveReserva, reserva.NumeroPedido]"
        >
          <div
            class="Rtable-cell status-cell"
            [ngClass]="checkStatusColor(reserva.Status)"
          >
            <div class="Rtable-cell--content status-content">
              {{ checkStatus(reserva.Status) }}
            </div>
          </div>
          <div class="Rtable-cell localizador-cell">
            <div class="Rtable-cell--content localizador-content">
              {{ reserva.ClaveReserva }}
            </div>
          </div>
          <div class="Rtable-cell fecha-cell">
            <div class="Rtable-cell--content fecha-content">
              {{ reserva.FechaEntrada }} - {{ reserva.HoraEntrada }}
            </div>
          </div>
          <div class="Rtable-cell cliente-cell">
            <div class="Rtable-cell--content cliente-content">
              {{ reserva.NumeroPedido }}
            </div>
          </div>
          <div class="Rtable-cell cliente-cell">
            <div class="Rtable-cell--content cliente-content">
              {{ reserva.NumeroEntradasTotal }}
            </div>
          </div>
          <div class="Rtable-cell correo-cell">
            <div class="Rtable-cell--content correo-content">
              {{ reserva.clienteCompra.Email }}
            </div>
          </div>
          <a
            [routerLink]="[reserva.ClaveReserva, reserva.NumeroPedido]"
            class="localInfo"
            title="Localizador Info"
          >
            <img
              class="svg"
              src="assets/img/icon-info.svg"
              alt="Localizador Info"
            />
          </a>
        </div>
      </div>
    </div>

    <ul class="pagination" *ngIf="pager.pages && pager.pages.length > 1">
      <li>
        <a
          (click)="setPage(pager.currentPage - 1)"
          title="irInicio"
          class="arrow"
        >
          <img
            class="svg leftarrow"
            src="assets/img/active-arrow.svg"
            alt="icono prev"
          />
        </a>
      </li>
      <!--       <li>
        <a (click)="setPage(pager.currentPage - 1)" title="Previo" class="arrow">
          <img class="svg leftarrow" src="assets/img/active-arrow.svg" alt="icono prev" />
        </a>
      </li> -->
      <li *ngFor="let page of pager.pages">
        <a
          (click)="setPage(page)"
          [ngClass]="{ active: pager.currentPage === page }"
          >{{ page }}</a
        >
      </li>
      <!--       <li>
        <a (click)="setPage(pager.currentPage + 1)" title="Próximo" class="arrow">
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
        </a>
      </li> -->
      <li>
        <a
          (click)="setPage(pager.currentPage + 1)"
          title="irFinal"
          class="arrow"
        >
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
        </a>
      </li>
    </ul>
  </ng-container>

  <!-- <div class="btn-bottom-wrap" *ngIf="pager.pages && pagedItems.length !== 0">
    <a class="GestionarButton aceptar" >
      <ng-container *ngIf="!loading; else cargando">
        Siguiente
      </ng-container>
    </a>
  </div> -->

  <ng-template #noResults>
    <div
      *ngIf="!localizadorService.noSearch"
      class="DetalleBox__noResultsMessage"
    >
      {{ 'MENSAJE_NO_DATOS' | translateV2 }}
    </div>
  </ng-template>

  <ng-template #cargando class="DetalleBox__noResultsMessage">
    <div class="lds-ring" style="transform: scale(0.6); align-self: center">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </ng-template>

  <ng-template #cargando2>
    <div class="DetalleBox__noResultsMessage">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </ng-template>
</section>
<ticketing-motivos-localizador
  *ngIf="itemsConMotivo"
  [entradas]="itemsConMotivo"
  id="motivosLocalizador"
  style="display:none"
></ticketing-motivos-localizador>
